import { BreadCrumbService } from './../breadcrumb/breadcrumb.service';
import { Component, Input, Output, EventEmitter, OnInit, ElementRef, HostListener,
   ViewEncapsulation, AfterViewInit, OnDestroy, AfterContentChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AccordionModel } from './accordion.model';
import { EmitterService } from './emitter.service';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  providers: [EmitterService],
  encapsulation: ViewEncapsulation.None
})
export class AccordionComponent implements OnInit, OnDestroy, AfterContentChecked {

  @Input() count: number;
  expand: boolean;
  accordionCollapse: boolean;
  accordionList: boolean[];
  accordionExpandCount = 0;
  accordionCollapseCount = 0;
  alreadyOpen = false;
  pathName = "";
  isFaq: boolean = false;
  @Input() accordionController: boolean;

  @Input() accordion: AccordionModel[];
  @Input() accordionHeading: String;
  private subscription: Subscription;

  constructor(private breadCrumbService: BreadCrumbService,
    protected router: Router, private el: ElementRef, private emitter: EmitterService) {
    this.subscription = this.emitter.subscribe(accData => {
      this.accordionToggle(accData);
    });
    this.pathName = window.location.pathname;
    if(this.pathName == "/businessconsole/faq") {
      this.isFaq = true;
    }
  }

  accordionToggle(accData) {
    accData.isActive = !accData.isActive;
    if (accData.isActive === true) {
      this.accordionExpandCount++;
      if (this.accordionCollapseCount > 0) {
        this.accordionCollapseCount = this.accordionCollapseCount - 1;
      }
      if (this.accordion.length === this.accordionExpandCount) {
        this.expand = true;
        this.accordionExpandCount = 0;
      }
    }else if (accData.isActive === false) {
      this.accordionCollapseCount++;
      if (this.accordionExpandCount > 0) {
        this.accordionExpandCount = this.accordionExpandCount - 1;
      }
      if (this.accordion.length === this.accordionCollapseCount) {
        this.expand = false;
        this.accordionCollapseCount = 0;
      }
    }
    /*  for (let i = 1; i < this.accordion.length; i++) {
        if (accData.id === i) {
          accData.isActive = true;
        } else {
        }
      } */
  }

  ngOnInit() {
  }

//TODO REMOVE USECASE SPECIFIC CODE
  ngAfterContentChecked() {
    const url = this.router.routerState.snapshot.url;
    const path = this.breadCrumbService.getBreadCrumbs();
    if (!path) return;
    const len = path.length;
    const previousRoute = len > 2 ? (path[len - 2].routerLink) : '/';
    if (url === '/faq' && previousRoute === '/signup' && this.accordion[3].category === 'What is network restriction?'
      && this.alreadyOpen !== true) {
      this.accordion[3].isActive = true;
      this.alreadyOpen = true;
    }
  }

  private expandAll(open) {
    console.log(open);
    if (open === 'open') {
      for (let l = 0; l < this.accordion.length; l++) {
        this.accordion[l].isActive = true;
        console.log(this.accordion[l].isActive);
      }
      this.expand = true;
    }
  }

  private collapseAll(close) {
    if (close === 'close') {
      for (let l = 0; l < this.accordion.length; l++) {
        this.accordion[l].isActive = false;
        console.log(this.accordion[l].isActive);
      }
      this.expand = false;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
